declare namespace $ {

	export class $mol_icon_flag extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=flag.view.tree.d.ts.map